import React, { Fragment} from 'react';

const TogglesUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row">
        <div className="left">
          <h1 className="page-title">The toggle is a control that is used to quickly switch between two possible states.</h1>
        </div>
        <div className="right copy-content">
          <p>Toggles are a quick way for the user to view and switch between enabled or disabled states. It should be used to turn something on or off instantly. If in the real world a physical switch would work for the action, a toggle is probably the best component to use.</p>
        </div>
      </article>
    </section>

    <section className="bg-grey with-padding flex-grow-1">
      <article className="flex-justify-end flex-row last">
        <div className="right copy-content">
          <h2 className="page-subtitle">Immediate Actions</h2>
          <p>Toggles do not require users to press a button to apply settings, the action should be immediate and change the information on the screen accordingly. If you need further confirmation from the user, a checkbox should be used. As an example, the exception toggle changes the background colour to indicate the user that a change has occurred.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default TogglesUsage;



// WEBPACK FOOTER //
// ./src/containers/elements/Toggles/TogglesUsage.js